/// <reference path="DOMAttached.js" />
/// <reference path="TextResource.js" />
/// <reference path="UrlTemplate.js" />
/// <reference path="GamesRace.js" />
/// <reference path="ToggleQuestionReader.js" />
/// <reference path="gameUtils/GamesTextToSpeech.js" />
/// <reference path="../../../gulp/node_modules/soundmanager2/script/soundmanager2-nodebug.js" />
/// <reference path="gameUtils/UpScaleImageHandler.js" />

var GamesMultiplayerQuizInstance = null;
var GamesQuizInstance = null;

class GamesMultiplayerQuiz extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		GamesMultiplayerQuizInstance = this;
		GamesQuizInstance = this;
		this.upScaledImageHandler = new UpScaledImageHandler(this);
		this.container = this.el.querySelector('.questionContainer');
		this.message = this.el.querySelector('span.message');
		this.tpReportQuestion = this.el.querySelector('.tpReportQuestion');
		this.beginSound = null;
		this.displayMath = this.options.DisplayMath;
		this.instance = this.options.instance;
		this.playFeedbackSound = this.options.FeedbackSoundOn;

		if (GenericSoundsInstance == null) {
			new GenericSounds(this.playFeedbackSound);
		}

		this.readQuestions = this.options.ReadQuestionsOn && this.options.TextToSpeechEnabled;

		if (GamesTextToSpeechInstance == null) {
			new GamesTextToSpeech(this, this.readQuestions, this.options.TextToSpeechEnabledByParent);
		}

		if (ToggleFeedbackSoundInstance && this.options.TextToSpeechEnabled) {
			ToggleFeedbackSoundInstance.url = this.options.ToggleFeedbackSoundUrl;
		}

		if (ToggleQuestionReaderInstance && this.options.TextToSpeechEnabled) {
			ToggleQuestionReaderInstance.url = this.options.ToggleQuestionReaderUrl;
			ToggleQuestionReaderInstance.showCorrectImage();
		}

		this.position = 0;
		this.questionNumber = 0;
		this.lockPageLoad = false;
		var finishInitialization = () => {
			if (this.playFeedbackSound) {
				this.sound();
			}
			if (this.options.useList) {
				this.safeObserve(this.el, 'click', this.onListClick.bind(this));
			} else {
				this.safeObserve(this.el, 'click', this.onSubmitButtonClick.bind(this));
				this.safeObserve(this.el, 'keypress', this.onKeypress.bind(this));
			}

			this.handleNextPageLoad();
		};

		if (soundManager.ok() || (!this.readQuestions && !this.playFeedbackSound)) {
			finishInitialization();
		} else {
			soundManager.onready(finishInitialization);
		}

		if (this.options.playingAgainstAki) {
			this.opponent = new GamesRaceOpponent(this.options.akiMinTimeout, this.options.akiMaxTimeout, this.options.akiProbabilityCorrect, this.options.endPosition, this.options.akiAnswerUrl);
			this.opponentAlive = true;
		}
	}

	sound() {
		this.beginSound = soundManager.createSound({ id: 'succ', url: '/snd/first_call.mp3' });
		this.beginSound.play({ onfinish: function() { this.destruct(); } });
	}

	onSubmitButtonClick(ev) {
		if (this.locked)
			return;

		var btn = ev.target.closest('.submitButton');
		if (!btn) {
			this.handleOtherClick(ev);
			return;
		}

		this.processInputSolution();
	}

	removeTextToSpeechEffects() {
		soundManager.stopAll();
		if (this.beginSound !== undefined && this.beginSound !== null) {
			this.beginSound.destruct();
		}
		GamesTextToSpeechInstance.removeTextToSpeechEffects();
	}

	onKeypress(ev) {
		if (this.locked)
			return;
		if (ev.keyCode == 13) {
			this.processInputSolution();
			ev.preventDefault();
			ev.stopPropagation();
		}
	}

	processInputSolution() {
		this.locked = true;
		this.lockPageLoad = true;

		this.success = this.checkInputSolution();

		this.el.querySelector('.solutionInput').style.display = 'none';

		this.playSound();

		if (this.success) {
			this.el.querySelector('.dispIfSolutionCorrect').style.display = '';
		} else {
			this.el.querySelector('.dispIfSolutionIncorrectWithCorrectSolution').style.display = '';
		}

		if (this.success) {
			if (this.position < this.options.endPosition - 2) {
				this.position += 2;
			} else {
				this.position = this.options.endPosition;
				this.opponentAlive = false;
				this.container.parentNode.style.backgroundColor = this.options.dullred;
			}
		} else if (this.position != 0) {
			this.position--;
		}
		GamesRaceInstance.moveDragonTo(0, this.position);
		this.questionNumber++;
		if (this.questionNumber == this.options.endPosition) {
			GamesRaceInstance.takeDragonDown(0, this.position);
		}

		axios(new UrlTemplate(this.options.processAnswerUrl).r('PLH_success', this.success).r('PLH_nquestion', -2).url, {
			method: 'get'
		}).then(this.onSuccess.bind(this));
	}

	checkInputSolution() {
		var i = 0;
		var input = this.el.querySelector('.solutionInput').querySelectorAll('input')[i];
		var solution = this.el.querySelector('.correctSolution').querySelectorAll('input')[i];

		while (input != undefined && solution != undefined) {
			if (input.value.gsub(/\s+/, '') != solution.value) {
				return false;
			}
			++i;
			input = this.el.querySelector('.solutionInput').querySelectorAll('input')[i];
			solution = this.el.querySelector('.correctSolution').querySelectorAll('input')[i];
		}
		return true;
	}

	handleOtherClick(ev) {
		var button = ev.target.closest('input');
		if (!button)
			return;
		ev.preventDefault();
		ev.stopPropagation();
		if (typeof(this.tpReportQuestion) != 'undefined') { // quickfix to prebent undefined access error from happening
			this.tpReportQuestion.style.display = 'block';
		}
	}

	onListClick(ev) {
		if (this.locked)
			return;

		this.lockPageLoad = true;

		var li = ev.target.closest('li');
		if (!li) {
			this.handleOtherClick(ev);
			return;
		}
		if (!li.closest('ol, ul'))
			return;

		this.removeTextToSpeechEffects();

		if (li.classList.contains('solution'))
			li.style.backgroundColor = 'green';
		else
			li.style.backgroundColor = 'red';
		this.locked = true;

		var question = this.el.querySelector('.question').innerHTML;
		var solution = this.el.querySelector('.solution').innerHTML;

		var message;
		this.success = li.classList.contains('solution');

		if (!this.success) {
			this.flashInterval = setInterval(this.flashCorrectSolution.bind(this), 250);
		}

		this.playSound();

		if (this.success) {
			if (this.position < this.options.endPosition - 2) {
				this.position += 2;
			} else {
				this.position = this.options.endPosition;
				this.opponentAlive = false;
				this.container.parentNode.style.backgroundColor = this.options.dullred;
			}
		} else if (this.position != 0) {
			this.position--;
		}
		this.questionNumber++;
		if (this.questionNumber == this.options.endPosition && this.position != this.options.endPosition) {
			GamesRaceInstance.takeDragonDown(0, this.position);
		} else {
			GamesRaceInstance.moveDragonTo(0, this.position);
		}

		axios(new UrlTemplate(this.options.processAnswerUrl).r('PLH_success', this.success).r('PLH_nquestion', this.pageLoadJSON.questionID).url, { 
			method: 'get'
		}).then(this.onSuccess.bind(this));
	}

	isOpponentAlive() {
		return this.opponentAlive;
	}

	handleProcessResult() {
		if (!this.success) {
			setTimeout(this.handleNextPageLoad.bind(this), 3000);
		} else {
			setTimeout(this.handleNextPageLoad.bind(this), 1500);
		}
	}

	flashCorrectSolution() {
		var sol = this.el.querySelector('.solution');
		if (sol.style.backgroundColor == 'green') {
			sol.style.backgroundColor = this.prevBgColor;
		} else {
			this.prevBgColor = sol.style.backgroundColor;
			sol.style.backgroundColor = 'green';
		}
	}

	handleNextPageLoad() {
		clearInterval(this.flashInterval);
		axios(this.getPageLoadUrl(), {
			method: 'get'
		}).then(this.onPageLoaded.bind(this));
	}

	handleNextSpecificPageLoad(messageInstance) {
		//handling race condition: opponent may already have answered the question correctly, so we do not need to load this
		if (!this.lockPageLoad && messageInstance == this.instance) {
			clearInterval(this.flashInterval);
			axios(this.getPageLoadUrl(), {
				method: 'get'
			}).then(this.onPageLoaded.bind(this));
		}
	}

	getPageLoadUrl() {
		return new UrlTemplate(this.options.loadUrl).url;
	}

	onSuccess(req) {
		this.json = req.data;
		this.handleProcessResult();
	}

	onPageLoaded(req) {
		try {
			this.pageLoadJSON = req.data;
		} catch (e) {
			legacyGlobal.handleFailedAJAJRequest();
			return;
		}
		if (this.customLoadEvent()) {
			this.showPage();
			this.locked = false;
			this.lockPageLoad = false;
			if (!this.options.useList) {
				if (this.el.querySelector('.solutionInput')) { // quickfix to prevent null access error from happening
					this.el.querySelector('.solutionInput').querySelector('input').focus();
				}
			}
		}
	}

	customLoadEvent() {
		return true;
	}

	showPage() {
		if (typeof this.pageLoadJSON == 'undefined') {
			return;
		}

		this.container.innerHTML = this.pageLoadJSON.page;
		if (this.el.querySelector('.question2')) {
			var questiontext = this.el.querySelector('.question2').firstChild.firstChild;
			var questionbox = this.el.querySelector('.question2');
			var questionContent = questiontext;
			var questionParent = questiontext.parentNode;
			while (typeof(questionContent.innerHTML) !== 'undefined') {
				questionParent = questionContent;
				questionContent = questionContent.innerHTML;
			}

			if (questionContent.length < 400) {
				questionParent.style.fontSize = '30px';
				questionParent.style.lineHeight = '30px';
				questionParent.style.align = 'center';

				if (160 < questionParent.scrollHeight) {
					questionParent.style.fontSize = '25px';
				}
				if (160 < questionParent.scrollHeight) {
					questionParent.style.fontSize = '20px';
				}
				questionbox.style.paddingTop = ((210 - questionParent.offsetHeight) / 2).toString() + 'px';
			}
		}
		if (PlayPauseButtonInstance != null && this.pageLoadJSON.soundFile) {
			PlayPauseButtonInstance.setSoundUrl(this.pageLoadJSON.soundFile, true, true);
		}

		this.renderMath();

		// Only if there exists a question element we are displaying a question;
		// only then we should read the question and its answers.
		if (this.el.querySelector('.question')) {
			this.createAndReadAllTextToSpeech();
		}
		this.upScaledImageHandler.initializeListenerForZoomInQuestionImg();
	}

	createAndReadAllTextToSpeech() {
		GamesTextToSpeechInstance.setTextToSpeechElements(this.createTextToSpeechElements());
		GamesTextToSpeechInstance.readSpeechForAllElementsInOrder();
	}

	createTextToSpeechElements() {
		var textToSpeechElements = [];

		textToSpeechElements.push(this.createQuestionElement());
		for (var i = 0; i < this.pageLoadJSON.answerPaths.length; i++) {
			textToSpeechElements.push(this.createAnswerElement(i));
		}

		return textToSpeechElements;
	}

	createQuestionElement() {
		var questionElement = {};

		questionElement.domElement = this.el.querySelector('.question');
		questionElement.identifier = 'question';
		questionElement.soundUrl = this.pageLoadJSON.questionPath;
		questionElement.highlightFontColor = '#7F82D2';
		questionElement.defaultFontColor = "white";

		return questionElement;
	}

	createAnswerElement(answerNumber) {
		var answerElement = {};

		answerElement.domElement = this.el.querySelector('.answer' + answerNumber);
		answerElement.identifier = 'answer' + answerNumber;
		answerElement.soundUrl = this.pageLoadJSON.answerPaths[answerNumber];
		answerElement.highlightFontColor = '#7F82D2';
		answerElement.defaultFontColor = "white";

		return answerElement;
	}

	getBackgroundColor(className) {
		var element = this.el.querySelector(className);
		if (typeof(element) !== 'undefined' && element !== null) {
			return window.getComputedStyle(element).getPropertyValue("background-color");
		} else {
			return '';
		}
	}

	getFontColor(className) {
		var element = this.el.querySelector(className);
		if (typeof(element) !== 'undefined' && element !== null) {
			return window.getComputedStyle(element).getPropertyValue("color");
		} else {
			return '';
		}
	}

	playSound() {
		if (this.success) {
			GenericSoundsInstance.successSound();
		} else {
			GenericSoundsInstance.failSound();
		}
	}

	// Ensures that all LaTeX math content is correctly rendered
	renderMath() {
		if (this.displayMath) {
			MathJax.Hub.Typeset();
		}
	}
}
